<template>
  <v-container class="pa-4">
    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="dataItem.image_url"
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3" style="margin-bottom: 160px">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ dataItem.name }}
            </p>
          </v-col>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0 mt-2">
              {{ $t("textTopRanking") }}
            </p>
            <v-card
              flat
              color="white"
              class="pa-2"
              v-if="topSpenders.length > 0"
            >
              <v-simple-table fixed-header style="overflow: scroll">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">{{ $t("textRank") }}</th>
                      <th class="text-center">{{ $t("phone") }}</th>
                      <th class="text-center">{{ $t("textTotalAmount") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(spender, index) in topSpenders"
                      :key="index"
                      v-bind:style="[
                        spender.isRank
                          ? {
                              backgroundColor: '#F3F3F3',
                              boxShadow:
                                'rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset',
                            }
                          : { backgroundColor: 'white' },
                      ]"
                    >
                      <td class="text-center">
                        <div v-if="spender.isMoreThanLimit">
                          . <br />
                          . <br />
                          . <br />
                        </div>
                        <v-row
                          class="d-flex justify-center align-center"
                          v-else
                        >
                          <v-icon
                            v-if="spender.isRank"
                            color="#FBC02D"
                            class="ma-1"
                          >
                            mdi-chevron-triple-right
                          </v-icon>
                          <div
                            :style="{
                              fontWeight: spender.isRank ? '700' : '',
                            }"
                          >
                            {{ spender.rank }}
                          </div>
                        </v-row>
                      </td>
                      <td class="text-center">
                        <div
                          v-if="spender.isMoreThanLimit != true"
                          :style="{
                            fontWeight: spender.isRank ? '700' : '',
                          }"
                        >
                          {{ spender.phone }}
                        </div>
                      </td>
                      <td
                        class="text-center"
                        :style="{
                          fontWeight: spender.isRank ? '700' : '',
                        }"
                      >
                        <div v-if="spender.isMoreThanLimit != true">
                          {{
                            Number.parseFloat(spender.total).toLocaleString(
                              "en-US",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>

            <div v-else>
              <v-img
                class="white--text mx-auto mt-10 empty"
                :src="require('@/assets/images/out-of-stock.png')"
                max-width="200px"
              >
              </v-img>
              <p class="text-center">{{ $t("errDataNotFound") }}</p>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import moment from "moment";
import { mapState } from "vuex";

export default {
  data: () => ({
    dataItem: [],
    userData: [],
    topSpenders: [],
    previousRouteName: null,
  }),
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm คือตัวแทนของ this
      const currentRouteName = to.name;
      if (from?.fullPath && from?.fullPath !== "/") {
        sessionStorage.setItem(
          currentRouteName + "_prev_route_name",
          from.name
        );
        vm.previousRouteName = from.name;
      } else {
        vm.previousRouteName = sessionStorage.getItem(
          currentRouteName + "_prev_route_name"
        );
      }
    });
  },
  async created() {
    await this.getMissionDetail();
    await this.getHeaderAndTopSpender();
  },
  methods: {
    redirectTo() {
      if (this.previousRouteName) {
        this.$router.go(-1);
      } else {
        this.$router.push({
          name: "mission",
        });
      }
    },
    getMissionDetail() {
      Axios.get("mission/getMission", {
        params: {
          mission_id: this.$route.params.id,
          view_in_period_remind_date: true,
          view_limit_reached: true,
        },
      })
        .then(({ data }) => {
          this.dataItem = data.data;
          this.$store.commit("login/SET_URL_REDIRECT", { urlRedirect: "" });
        })
        .catch((err) => {
          console.log("err :>> ", err);
        });
    },
    async getHeaderAndTopSpender() {
      const response = await Axios.get(
        `mission/getTopRankingMission/${this.$route.params.id}`
      );

      this.topSpenders = response.data.data.topSpender;
      this.userData = response.data.data.user;
      let limitTopSpender = response.data.limit_topSpender;
      if (
        this.topSpenders.length != 0 &&
        this.topSpenders.length < this.userData.currentRank &&
        this.userData.total != 0 &&
        this.userData.currentRank <= limitTopSpender
      ) {
        if (this.userData.higherRanker != null) {
          this.topSpenders.push({
            rank: "",
            isMoreThanLimit: true,
            phone: "",
            total: "",
            isRank: false,
            created_at: "",
          });
          this.topSpenders.push({
            rank: this.userData.higherRanker.rank,
            phone: this.userData.higherRanker.phone,
            total: this.userData.higherRanker.total,
            isRank: this.userData.higherRanker.isRank,
            created_at: this.userData.higherRanker.created_at,
          });
        }
        this.topSpenders.push({
          rank: this.userData.rank,
          phone: this.userData.phone,
          total: this.userData.total,
          isRank: true,
          created_at: this.userData.created_at,
        });
      } else {
        if (this.topSpenders.length > this.userData.currentRank - 1) {
          this.topSpenders[this.userData.currentRank - 1].isRank = true;
        }
      }
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
    ...mapState("login", ["mobile"]),
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "-";
      return moment(value).format("D MMMM YY");
    },
  },
};
</script>

<style>
.sd-body {
  margin-bottom: 20% !important;
}
</style>

<style scoped>
.ellipsis {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.spaceBottom {
  margin-bottom: 30%;
}

.sv-components-column .sd-action-bar #sv-nav-complete {
  display: none;
}

/* preview image  */
.sd-file__wrapper {
  display: none !important;
}

.sd-file__list {
  padding-top: 0;
  padding-bottom: 0;
  height: 100% !important;
  /* width: 100%; */
  max-height: none !important;
}

.sd-file__preview {
  height: 80% !important;
  min-height: 0 !important;
  /* width: 50% !important; */
}

.sd-file__image-wrapper {
  margin: auto !important;
}

.sd-file__image-wrapper img {
  height: 100% !important;
  width: 100% !important;
}

.sd-file__sign {
  display: none;
}

.sv-action-bar--default-size-mode {
  margin-top: 20px;
}

.sd-navigation__next-btn,
.sd-navigation__prev-btn {
  margin-bottom: 80px !important;
}

.v-text-field--outlined >>> fieldset {
  border-width: 0px;
}

/* ::v-deep .sd-timer {
  display: none !important;
} */

img {
  width: 100% !important;
}
</style>
